import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';

import HomeIcon from '@src/componentsNew/Icons/Icons/HomeIcon';
import SelectedHomeIcon from '@src/componentsNew/Icons/Icons/SelectedHomeIcon';
import ShopIcon from '@src/componentsNew/Icons/Icons/ShopIcon';
import AccountIcon from '@src/componentsNew/Icons/Icons/AccountIcon';

// Components
import CartQuantityIcon from '@src/componentsNew/Icons/CartQuantityIcon/CartQuantityIcon';

// constants
import { baseUrl, mobileShopTabUrl, cartUrl, accountUrl } from '@src/app/routes';

const selectedTabColor = '#212121';
const normalTabColor = '#9E9E9E';

const getValueFromPathname = (pathname) => {
  if (pathname === baseUrl) {
    return 0;
  } else if (pathname === mobileShopTabUrl) {
    return 1;
  } else if (pathname === cartUrl) {
    return 2;
  } else if (pathname === accountUrl) {
    return 3;
  }
};

const useStyles = makeStyles({
  root: {
    position: 'fixed',
    bottom: '-1px',
    width: '100%',
    minWidth: '340px',
    height: '66px',
    boxShadow: '0px 1px 8px 0px #0000001F',
    zIndex: 3,

    '& .MuiButtonBase-root': {
      alignItems: 'start',
    },
    '& .MuiBottomNavigationAction-root': {
      color: normalTabColor,
      maxWidth: 'unset',
      paddingTop: '10px',
    },
    '& .Mui-selected': {
      fontSize: '11px',
      color: selectedTabColor,
    },
    '& .MuiBottomNavigationAction-label': {
      fontFamily: 'Poppins, sans-serif',
      fontSize: '11px',
    },
  },
});

const urlObj = {
  0: baseUrl,
  1: mobileShopTabUrl,
  2: cartUrl,
  3: accountUrl,
};

function BottomNavigationBar() {
  const classes = useStyles();
  const history = useHistory();
  const currentPath = history.location.pathname;

  const [value, setValue] = useState(getValueFromPathname(currentPath));

  useEffect(() => {
    setValue(getValueFromPathname(currentPath));
  }, [currentPath]);

  const onChangeTabHandler = (e, value) => {
    history.push(urlObj[value]);
    setValue(value);
  };

  return (
    <BottomNavigation
      className={classes.root}
      value={value}
      showLabels
      onChange={(event, newValue) => onChangeTabHandler(event, newValue)}
    >
      <BottomNavigationAction label="Home" icon={value === 0 ? <SelectedHomeIcon /> : <HomeIcon />} />
      <BottomNavigationAction
        label="Shop"
        icon={
          <ShopIcon fillColor={value === 1 ? selectedTabColor : ''} strokeColor={value === 1 ? selectedTabColor : ''} />
        }
      />
      <BottomNavigationAction
        label="Bag"
        icon={<CartQuantityIcon isMobile={true} isBottomNav={true} isSelected={value === 2} />}
      />
      <BottomNavigationAction
        label="Account"
        icon={
          <AccountIcon
            fillColor={value === 3 ? selectedTabColor : ''}
            strokeColor={value === 3 ? selectedTabColor : normalTabColor}
          />
        }
      />
    </BottomNavigation>
  );
}

export default BottomNavigationBar;
